import { InputNumber } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import formatIntegerBySpace from '../../../../../../../../../../helpers/formatters/format-integer-by-space'

interface PriceProps {}

const Price: FC<PriceProps> = () => {
    const name = 'price'

    return (
        <Form.Item name={name} label={'Цена'}>
            <InputNumber formatter={formatIntegerBySpace} />
        </Form.Item>
    )
}

export default Price
